interface Urls {
  libreApiUrl?: string;
  lluApiUrl?: string;
  clmApiUrl?: string;
}

/** Reference used to store urls */
export const urls = {
  apiUrl: '',
  libreApiUrl: '',
  clmApiUrl: '',
};

/**
 * Sets the urls object to be ready for services
 * - config: object - The environment config
 */
export const setUrls = (config: Partial<Urls>, app: App): void => {
  const { libreApiUrl, lluApiUrl, clmApiUrl } = config;

  const appUrls: Record<App, string | undefined> = {
    libre1: libreApiUrl,
    clm: clmApiUrl,
    llu5: lluApiUrl,
  };

  Object.assign(urls, {
    apiUrl: appUrls[app],
    clmApiUrl,
    libreApiUrl, // set libreApiUrl until we have the endpoint config for llu
  });
};

export const getDocumentPathFromLanguage = (
  document: { [key: string]: string } | undefined,
  lang: string
): string => {
  if (!document) {
    return '';
  }

  const path = document[lang.toLowerCase()] || document.default || document['en-us'];

  return path ?? '';
};

export const detectTheme = (
  urlParams: URLSearchParams
): 'polarisDark' | 'polarisLight' | 'otcDark' | 'otcLight' => {
  const productParam = urlParams.get('product') as 'libre1' | 'otc' | null;

  const theme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'Dark' : 'Light';

  return !productParam || productParam === 'libre1' ? `polaris${theme}` : `otc${theme}`;
};

export const getTheme = () => {
  const urlParams = new URLSearchParams(window.location.search);

  const themeParam = urlParams.get('theme') as
    | 'polarisLight'
    | 'polarisDark'
    | 'otcLight'
    | 'otcDark'
    | null;

  return themeParam ? themeParam : detectTheme(urlParams);
};

export const getApp = () => {
  const urlParams = new URLSearchParams(window.location.search);

  const app = urlParams.get('app') as App | null;

  return app ?? 'libre1';
};

export const getRegistrationEndpoint = (app: App) => {
  switch (app) {
    case 'libre1':
      return 'patients';
    case 'llu5':
      return 'caregivers';
    default:
      return 'patients';
  }
};

export const getTermsOfUseId = (app: App) => {
  switch (app) {
    case 'libre1':
      return 'touLibre';
    case 'llu5':
      return 'toullu';
    default:
      return 'touLibre';
  }
};

export const generateUserAgentHeader = (
  app?: string,
  appVersion?: string,
  osType?: string,
  osVersion?: string
) => {
  return `${app ? app : 'none'};${appVersion ? appVersion : 'none'};${osType ? osType : 'none'};${
    osVersion ? osVersion : 'none'
  }`;
};
